<template>
  <div class="component">
    <div v-if="fullPage">
      <el-row v-if="favoriteProductsInfo.length">
        <el-col :span="22" :offset="1">
          <el-row type="flex" class="product-card-row">
            <el-col v-for="(product, index) in favoriteProductsInfo" class="product-card-wrapper" :key="index"
              :xl="{ span: 4 }" :lg="{ span: 6 }" :md="{ span: 8 }" :sm="{ span: 12 }" :xs="{ span: 24 }">
              <product-card-view
                :categoryTitle="product.newProductCategory ? product.newProductCategory[product.newProductCategory.length - 1].title : ''"
                :product="product" :currentUser="currentUser" :interactiveFavorite="true" :shadowOnHover="false"
                :productsPage="false" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <favorites-empty-state v-else />
    </div>
    <div v-else>
      <div v-if="favoriteProductsInfo.length">
        <div class="header-container">
          <h2 class="heading">{{ homeFavorites.favoritesHeadline }}</h2>
        </div>
      </div>

      <el-row>
        <el-col v-if="favoriteProductsInfo.length" :span="22" :offset="1">
          <div class="carousel-container">
            <carousel :navigationEnabled="false" :scrollPerPage="true"
              :perPageCustom="[[0, 1], [768, 2], [992, 3], [1200, 4]]" :speed="1000" paginationActiveColor="#E50B19"
              paginationColor="#454A4D">
              <slide v-for="(product, index) in favoriteProductsInfo" :key="index">
                <div class="slide">
                  <product-card-view
                    :categoryTitle="product.newProductCategory ? product.newProductCategory[product.newProductCategory.length - 1].title : ''"
                    :product="product" :currentUser="currentUser" :interactiveFavorite="true" :shadowOnHover="false"
                    :productsPage="false" />
                </div>
              </slide>
            </carousel>
          </div>
          <div class="button-container">
            <router-link :to="{ name: 'Favorites' }">
              <button class="button el-button el-button--primary">
                {{ $t('favoritesSeeAll') }}
              </button>
            </router-link>
          </div>
        </el-col>
        <favorites-empty-state v-else />
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import home from './';
import user from '../user'
import products from '../products'
import { Carousel, Slide } from 'vue-carousel';
import ProductCardView from '../products/ProductCardView'
import FavoritesEmptyState from '@/components/favorites/FavoritesEmptyState.vue'

export default {
  name: 'HomeFavorites',
  props: [
    'fullPage'
  ],
  computed: {
    ...mapState(user.store.namespace, [
      'currentUser'
    ]),
    ...mapState(home.store.namespace, [
      'homeFavorites',
    ]),
    ...mapState(products.store.namespace, [
      'products',
    ]),
    ...mapGetters(products.store.namespace, [
      'getProductById',
    ]),
    favoriteProductsInfo() {
      let favoriteProductsArray = []
      this.currentUser.favoriteProducts.forEach((productId) => {
        if (this.getProductById(productId)) {
          favoriteProductsArray.push(this.getProductById(productId))
        }
      })
      return favoriteProductsArray;
    },
    highlightedProduct() {
      if (!this.homeFavorites || !this.homeFavorites.favoritesEmptyStateFeaturedProduct || !this.homeFavorites.favoritesEmptyStateFeaturedProduct[0]) {
        return null;
      }
      return this.getProductById(Number(this.homeFavorites.favoritesEmptyStateFeaturedProduct[0].id))
    },
    emptyStateBackgroundImageURL() {
      if (!this.homeFavorites || !this.homeFavorites.favoritesEmptyStateBackgroundImage || !this.homeFavorites.favoritesEmptyStateBackgroundImage[0]) {
        return '';
      }
      return this.homeFavorites.favoritesEmptyStateBackgroundImage[0].url || '';
    }
  },
  components: {
    Carousel,
    Slide,
    ProductCardView,
    FavoritesEmptyState,
  },
  methods: {
  },
  data() {
    return {
    }
  },
}

</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.slide {

  // adjust image and card height by resolution to handle different
  // numbers of cards per row

  @include res(lg-and-up, $--breakpoints-spec) {
    --image-height: 18vw;
  }

  @include res(md-only, $--breakpoints-spec) {
    --image-height: 24vw;
  }

  @include res(sm-only, $--breakpoints-spec) {
    --image-height: 36vw;
  }

  @include res(xs-only, $--breakpoints-spec) {
    --image-height: 65vw;
  }

  padding: 10px;
  width: 100%;

}

:deep(.VueCarousel-dot) {
  outline: none !important;
}

:deep(.VueCarousel-slide) {
  display: flex;
}

.heading {
  color: $--color-white;
  padding: 30px 0px 30px 60px;

  @include res(md-and-down, $--breakpoints-spec) {
    padding: 30px 0 30px 40px;
  }
}

.header-container {
  background-image: url('@/assets/images/large-rectangle-background.svg');
  background-repeat: no-repeat;
  background-size: cover;
  width: 40%;
  margin-bottom: 75px;
  margin-top: 50px;

  @include res(sm-and-down, $--breakpoints-spec) {
    margin-bottom: 25px;
    margin-top: 25px;
    background-size: cover;
    width: 90%;
  }

}

.button {
  padding: 20px 35px;
  font-size: 14px;
}

.button-container {
  text-align: center;
  margin-bottom: 80px;

  @include res(sm-and-down, $--breakpoints-spec) {
    margin-bottom: 60px;
  }
}

.carousel-container {
  margin-bottom: 60px;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 35px;
  }
}

.empty-state-wrapper {
  background-color: $--color-secondary;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 80px;
  margin-top: 110px;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 55px;
    margin-top: 65px;
  }
}

.empty-state-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;

  @include res(md-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
  }
}


:deep(.empty-state-copy) {
  width: 45%;
  margin-top: 100px;
  margin-bottom: 100px;

  @include res(md-and-down, $--breakpoints-spec) {
    width: 100%;
    text-align: center;
  }

  & h2 {
    color: $--color-white;
    text-transform: uppercase;
  }

  & p {
    color: $--color-white;
    font-size: 1.125rem
  }
}

:deep(.empty-state-cta) {
  white-space: normal;
}

.empty-state-card-container {
  width: 40%;
  position: relative;
  top: -40px;

  //assign image height
  @include res(lg-and-up, $--breakpoints-spec) {
    --image-height: 24vw;
  }

  @include res(md-and-down, $--breakpoints-spec) {
    display: none;
  }

}

.product-card-wrapper {
  padding: 10px;
}

.product-card-row {
  flex-wrap: wrap;

  // adjust image height by resolution to handle different
  // numbers of cards per row

  @include res(xl-only, $--breakpoints-spec) {
    --image-height: 12vw
  }

  @include res(lg-only, $--breakpoints-spec) {
    --image-height: 18vw
  }

  @include res(md-only, $--breakpoints-spec) {
    --image-height: 24vw
  }

  @include res(sm-only, $--breakpoints-spec) {
    --image-height: 36vw
  }

  @include res(xs-only, $--breakpoints-spec) {
    --image-height: 72vw
  }
}
</style>

